module.exports = ['$sce', 'Strings', function ($sce, Strings) {
    return {
        restrict: "A",
        link: function link($scope, $element, $attrs) {
            $scope.$watch(function () {
                return Strings[$attrs['pdTextBlock']]
            }, function (html) {
                if(!html) {
                    html = `Unknown string '${$attrs['pdTextBlock']}'`;
                }
                $element.html(html);
            })
        }
    };
}];
